<template>
    <standard-layout :header="'Reservierung ' + reservation.number" v-if="reservation">
        <template v-slot:main>
            <reservation-detail :reservation="reservation" @move="moveReservation($event)"/>
            <div class="row mt-2">
                <div class="col-12">
                    <button class="btn btn-danger btn-sm"
                            @click="cancelReservation">
                        Stornieren
                    </button>
                    <button class="btn btn-success btn-sm ml-1"
                            @click="confirmReservation">
                        Bestätigen
                    </button>
                    <button class="btn btn-warning btn-sm ml-1"
                            @click="createOrderForReservation">
                        Bestellung zu Reservierung erstellen
                    </button>
                  <button class="btn btn-warning btn-sm ml-1"
                          @click="resendReservationEmail(false)">
                    Erneut senden
                  </button>
                  <button class="btn btn-warning btn-sm ml-1"
                          @click="resendReservationEmail(true)">
                    Vorabinformation senden
                  </button>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 text-secondary h5">Erstellt von</div>
                <div class="col-12">
                    <customer-detail :customer="reservation.customer"/>
                </div>
            </div>
            <div class="row mt-3" v-if="order">
                <div class="col-12 text-secondary h5">Bestellung</div>
                <div class="col-12">
                    <order-detail :order="order"/>
                </div>
            </div>
        </template>
    </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import CustomerDetail from "@/components/customer/CustomerDetail";
import ReservationDetail from "@/components/reservation/ReservationDetail";
import OrderDetail from "@/components/order/OrderDetail";
import {handleDates} from "@/utils/axios-utils";

export default {
    components: {ReservationDetail, StandardLayout, CustomerDetail, OrderDetail},
    props: {
        id: String
    },
    data() {
        return {
            reservation: null,
            order: null
        }
    },
    watch: {
        id: {
            immediate: true,
            handler: 'loadReservation'
        }
    },
    methods: {
        async loadReservation() {
            this.reservation = await this.$api.get(`/reservations/${this.id}`)
                .then(res => res.data)
                .catch(err => this.handleError(err))
            this.order = await this.$api.get('/orders', {
                params: {
                    reservation: this.reservation.number
                }
            }).then(res => {
                if (res?.data.length > 0)
                    return res.data[0]
                return null
            }).catch(err => {
                console.log(err.response.data)
                if (err.response?.data?.code !== 2)
                    this.handleError(err)
            })
        },
        cancelReservation() {
            this.$api.delete(`/reservations/${this.id}`)
                .then(res => {
                    this.reservation = res.data
                    this.showInfo("Die Reservierung wurde storniert.")
                }).catch(err => this.handleError(err))
        },
        confirmReservation() {
            this.$api.put(`/reservations/${this.id}`, {}, {
                params: {
                    command: 'confirm'
                }
            }).then(res => {
                this.reservation = res.data
                this.showInfo("Die Reservierung wurde bestätigt.")
            }).catch(err => this.handleError(err))
        },
        resendReservationEmail(preInformation) {
            this.$api.put(`/reservations/${this.id}`, {}, {
                params: {
                    command: preInformation ? 'send_pre' : 'send'
                }
            }).then(res => {
                this.reservation = res.data
                this.showInfo("Die Reservierung-Information wurde versandt.")
            }).catch(err => this.handleError(err))
        },
        async createOrderForReservation() {
            handleDates(this.reservation)
            this.$api.post('/carts', {}, {
                params: {
                    reservation: this.reservation.number
                }
            }).then(response => {
                console.log("res: " + response)
                const cart = response.data
                this.order = this.$api.post('/checkout', {
                    cartId: cart.id,
                    paymentProcessor: 'payByInvoiceProcessor'
                }).then(res => res.data)
                    .catch(err => this.handleError(err))
            }).catch(error => this.handleError(error))
        }
    }
}
</script>
